import { HelpMoreButton } from "modules/Call/components/HelpMoreMenuWrapper/HelpMoreButton"
import { HelpModal } from "modules/Call/components/HelpMoreMenuWrapper/HelpModal"

interface Props {
    isOpenedHelpModal: boolean
    isPsychotherapyMode?: boolean
    setIsPsychotherapyMode?: () => void
    onClickMoreButton?: (isOpen: boolean, tooltipRef: HTMLDivElement | null) => void
    toggleIsOpenedHelpModal: () => void
}

export function HelpMoreMenuWrapper({
    isOpenedHelpModal,
    setIsPsychotherapyMode,
    isPsychotherapyMode,
    onClickMoreButton,
    toggleIsOpenedHelpModal,
}: Props) {
    return (
        <>
            <HelpMoreButton
                isPsychotherapyMode={isPsychotherapyMode}
                onClick={toggleIsOpenedHelpModal}
                onClickMoreButton={onClickMoreButton}
                setIsPsychotherapyMode={setIsPsychotherapyMode}
            />
            <HelpModal isOpen={isOpenedHelpModal} openToggle={toggleIsOpenedHelpModal} />
        </>
    )
}
